export const TOGGLE_NAV_DRAWER = "TOGGLE_NAV_DRAWER";
export const TOGGLE_SHOW_HEADER_FOOTER = "TOGGLE_SHOW_HEADER_FOOTER";
export const CHANGE_ACTIVE_NAV_BOX_ITEM = "CHANGE_ACTIVE_NAV_BOX_ITEM";
export const LOADING_SHAHRZAD = "LOADING_SHAHRZAD";
